// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wx-z","tooltipWrapper":"xx-z","icon":"yx-z","tooltip":"zx-z","content":"Ax-z"};